module.exports = __webpack_public_path__ + "img/icon-user.95adc02b1de0dab77cec8f769cb6bf19.png";